import { render } from "./ProfileIcon.vue?vue&type=template&id=5a70171a"
import script from "./ProfileIcon.vue?vue&type=script&lang=js"
export * from "./ProfileIcon.vue?vue&type=script&lang=js"
script.render = render

export default script